import type { BuyerRequest } from '../api/types';

export const propertyTypeLabels: Record<string, string> = {
  APARTMENT: 'Wohnung',
  HOUSE: 'Haus',
  MULTI_FAMILY: 'Mehrfamilienhaus',
  LAND: 'Grundstück',
  COMMERCIAL: 'Gewerbe',
};

export const purposeLabels: Record<BuyerRequest['purpose'], string> = {
  UNKNOWN: 'offen',
  OWN_USE: 'selbst wohnen',
  INVESTMENT: 'Kapitalanlage',
};

const euro = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

// buyerProfileChips: das Suchprofil als kurze Stichworte (Objektart, Zweck, Ort, Größe, Einheiten, Budget).
export function buyerProfileChips(b: BuyerRequest): string[] {
  const out = b.property_types.map((t) => propertyTypeLabels[t] ?? t);
  if (b.purpose !== 'UNKNOWN') out.push(purposeLabels[b.purpose]);
  if (b.location) out.push(b.radius_km ? `${b.location} + ${b.radius_km} km` : b.location);
  if (b.living_area_min || b.living_area_max) {
    out.push(b.living_area_max ? `${b.living_area_min ?? ''}–${b.living_area_max} m²` : `ab ${b.living_area_min} m²`);
  }
  if (b.rooms_min) out.push(`ab ${String(b.rooms_min).replace('.', ',')} Zimmer`);
  if (b.units_min || b.units_max) out.push(b.units_max ? `${b.units_min ?? ''}–${b.units_max} Einheiten` : `ab ${b.units_min} Einheiten`);
  if (b.budget_max) out.push(`bis ${euro.format(b.budget_max)} €`);
  return out;
}
